import * as S from './styles';

type Props = {
  children: JSX.Element;
};

export const ResponsivenessWrapper: React.FC<Props> = ({ children }) => {
  return (
    <S.Container>
      <S.Layer>
        <S.Wrapper>{children}</S.Wrapper>
      </S.Layer>
    </S.Container>
  );
};
